import classnames from 'classnames/bind'
import InputForCopy from 'components/input_for_copy'
import QRCode from 'qrcode.react'
import * as React from 'react'
import { FC, ReactElement, ReactNode, useEffect, useRef, useState } from 'react'
import { capitalize } from 'lodash'
import styles from './share_url.module.scss'

const cx = classnames.bind(styles)
const ShareUrl: FC<{
  buttonClassName?: string
  buttonIcon?: ReactElement
  buttonValue: string
  className?: string
  disabled?: boolean
  enableQrcode?: boolean
  helpBlock?: ReactNode
  labelForInput?: string
  labelForQrcode?: string
  placement?: string
  selectorClassName?: string
  url: string
}> = ({
  buttonClassName,
  buttonIcon,
  buttonValue,
  className,
  disabled = false,
  enableQrcode = false,
  helpBlock,
  labelForInput,
  labelForQrcode,
  placement = 'left',
  selectorClassName,
  url
}) => {
  const [show, setShowState] = useState(false)
  const containerRef = useRef(null)

  useEffect(() => {
    document.addEventListener('click', handleClickOutside)
    return () => document.removeEventListener('click', handleClickOutside)
  }, [show])

  const handleClickOutside = (event: MouseEvent) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setShowState(false)
    }
  }

  const qrCode = (
    <div className={styles.shareItemQrcode}>
      {labelForQrcode ? <div className={cx(styles.label, styles.labelForQrcode)}>{labelForQrcode}</div> : null}
      <div className={styles.qrCodeWrapper}>
        <QRCode value={url} size={96} />
      </div>
    </div>
  )

  return (
    <div className={cx(className, styles.container)} ref={containerRef}>
      <button
        type="button"
        className={cx(buttonClassName, styles.button, {
          buttonActive: show
        })}
        onClick={() => setShowState(true)}
        disabled={disabled}
      >
        {buttonIcon || null}
        <span className={styles.buttonValue}>{buttonValue || null}</span>
      </button>
      {show ? (
        <div className={cx(selectorClassName, styles.selector, styles[`selector${capitalize(placement)}`])}>
          {helpBlock || null}
          <div
            className={cx({
              shareItemInput: enableQrcode,
              shareItemInputOnly: !enableQrcode
            })}
          >
            {labelForInput ? <div className={cx(styles.label, styles.labelForInput)}>{labelForInput}</div> : null}
            <InputForCopy value={url} />
          </div>
          {enableQrcode ? qrCode : null}
        </div>
      ) : null}
    </div>
  )
}

export default ShareUrl
